module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/diy_event-f7c288d87ac70800cee9a4386e9bca2c.jpg";